import Link from "next/link";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";

export function StartSellingSection() {
  return (
    <Card className="border-primary/20 bg-gradient-to-br from-primary/10 to-background shadow-sm">
      <CardHeader>
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-primary">
          Start Selling
        </p>
        <CardTitle className="text-3xl font-black tracking-tight">
          Grow your farm shop business with Efasol.
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <p className="text-sm leading-6 text-muted-foreground">
          List products and reach customers across your county.
        </p>
        <div className="grid gap-3 sm:grid-cols-2">
          {[
            { title: "Your storefront", description: "Create your own digital shop." },
            { title: "Grow sales", description: "Reach more local customers." },
            { title: "Customer base", description: "Build loyal repeat buyers." },
            { title: "Earn more", description: "Track and fulfill orders faster." },
          ].map((item) => (
            <div key={item.title} className="rounded-sm border border-border bg-card p-4 shadow-sm">
              <div className="font-semibold text-foreground">{item.title}</div>
              <p className="mt-1 text-sm text-muted-foreground">{item.description}</p>
            </div>
          ))}
        </div>
        <Button asChild className="rounded-sm bg-emerald-600 text-white hover:bg-emerald-700">
          <Link href="/shop/store-list">Discover store listings in every category</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
